"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  DeleteCriteriaRequest,
  MindstringPrototype,
} from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { deleteCriteria } from "../api/deleteCriteria";
import { criteriaKeys } from "../queries/keys";

interface UseDeleteCriteriaMutationProps {
  targetId?: string | null;
  prototypeCategory?: MindstringPrototype | null;
}

export default function useDeleteCriteriaMutation({
  targetId,
  prototypeCategory,
}: UseDeleteCriteriaMutationProps) {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();
  const queryKey = targetId
    ? criteriaKeys.list({
        targetId,
        prototypeCategory: prototypeCategory ?? undefined,
      })
    : criteriaKeys.all;

  return useMutation({
    mutationFn: (request: DeleteCriteriaRequest) =>
      deleteCriteria(accessToken, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey });
    },
  });
}
